import * as React from "react";
import { forwardRef } from "react";
const SvgHamburger = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M21 18.5H3V16.5H21V18.5ZM21 13.5H3V11.5H21V13.5ZM21 8.5H3V6.5H21V8.5Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgHamburger);
export { ForwardRef as ReactComponent };
